import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';

const columnRectangle = (options?: ShapeProps['options']): ShapeProps => ({
  shapeName: 'rect',
  options: {
    h: 0.52,
    w: 3.2,
    x: 0.74,
    y: 1.56,
    fill: {
      color: theme.colors.blue,
    },
    ...options,
  },
});

const columnTriangle = (options?: ShapeProps['options']): ShapeProps => ({
  shapeName: 'triangle',
  options: {
    h: 0.23,
    w: 0.41,
    x: 2.14,
    y: 2.08,
    rotate: 180,
    fill: {
      color: theme.colors.blue,
    },
    ...options,
  },
});

const columnShapes: ShapeProps[] = [
  columnRectangle(),
  columnTriangle(),
  columnRectangle({ x: 4.34, w: 3.76 }),
  columnTriangle({ x: 6 }),
  columnRectangle({ x: 8.53, w: 4.42 }),
  columnTriangle({ x: 10.56 }),
];

export const arrowOptionsFromValue = (
  value: number
): ShapeProps['options']['line'] =>
  value >= 0
    ? { beginArrowType: 'triangle', color: theme.colors.inmarketGreen }
    : { endArrowType: 'triangle', color: theme.colors.red };

const keyResultsShapes = (value: number): ShapeProps[] => [
  {
    shapeName: 'rect',
    options: {
      h: 4.59,
      w: 3.74,
      x: 4.36,
      y: 2.45,
      fill: {
        color: theme.colors.black,
        transparency: 25,
      },
    },
  },
  {
    shapeName: 'line',
    options: {
      h: 0.4,
      w: 0,
      x: 7,
      y: 3.08,
      line: {
        width: 5,
        ...arrowOptionsFromValue(value),
      },
    },
  },
  {
    shapeName: 'rect',
    options: {
      h: 1.53,
      w: 3.41,
      x: 4.52,
      y: 3.88,
      fill: {
        color: theme.colors.darkGray,
        transparency: 49,
      },
      line: {
        width: 1,
        color: theme.colors.inmarketGreen,
      },
    },
  },
];

export const shapes = (
  driverShapes: ShapeProps[],
  incrementalLift: number
): ShapeProps[] => [
  ...columnShapes,
  ...keyResultsShapes(incrementalLift),
  ...driverShapes,
];
